import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import CountUp from "react-countup";
import Widget from "../../../../../components/Widget/Widget";
import { Row, Col } from "reactstrap";

const reactions = [
  {
    type: "like",
    icon: (
      <motion.div
        animate={{ scale: [1, 1.5, 1], rotate: [0, -10, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        style={{
          width: "30px",
          height: "30px",
          backgroundImage: "url('/icons/like.svg')",
          backgroundSize: "cover",
        }}
      ></motion.div>
    ),
    color: "#1877F2",
  },
  {
    type: "love",
    icon: (
      <motion.div
        animate={{ scale: [1, 1.3, 1], rotate: [0, -5, 5, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        style={{
          width: "30px",
          height: "30px",
          backgroundImage: "url('/icons/love.svg')",
          backgroundSize: "cover",
        }}
      ></motion.div>
    ),
    color: "#E0245E",
  },
  {
    type: "haha",
    icon: (
      <motion.div
        animate={{ scale: [1, 1.2, 1], rotate: [0, 15, -15, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        style={{
          width: "30px",
          height: "30px",
          backgroundImage: "url('/icons/haha.svg')",
          backgroundSize: "cover",
        }}
      ></motion.div>
    ),
    color: "#F7B928",
  },
];

const PageReactios = (props) => {
  const { counters, setCounters, loading, setLoading } = props;

  const fetchData = async (firstLoad) => {
    if(firstLoad){
      setLoading(true);
    }
    try {
      const response = await axios.get(
        "https://eadash.arabiansystems.com/api/Dashboard/FacebookAnalytics/PageReactios"
      );
      const data = response.data.reactions;

      setCounters((prev) => ({ ...prev, like: data.like }));
      setCounters((prev) => ({ ...prev, love: data.love }));
      setCounters((prev) => ({ ...prev, haha: data.haha }));
      setCounters((prev) => ({ ...prev, wow: data.haha }));
      setCounters((prev) => ({ ...prev, sad: data.sorry }));
      setCounters((prev) => ({ ...prev, angry: data.anger }));

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(true);
    const interval = setInterval(() => {
      fetchData(false);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Widget
      fetchingData={loading}
      title={
        <div style={{ display: "flex", flexDirection: "row", gap: "30px" }}>
          <img src="/icons/reactios.png" width={window.innerWidth < 1576 ? "40" : "60"} />
          <h6 style={{ color: "#f4f4f599" }} className="m-0">
            Social Media Reactios
          </h6>
        </div>
      }
    >
      <div className="height75 padding20" style={{ textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
          {reactions.map(({ type, icon, color }) => (
            <motion.div
              key={type}
              whileHover={{ scale: 1.3 }}
              whileTap={{ scale: 0.9 }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ marginBottom: "10px" }}>{icon}</div>
              <span
                style={{
                  fontSize: "14px",
                  color: color,
                  fontWeight: "bold",
                }}
              >
                <CountUp
                  start={0}
                  end={counters[type]}
                  duration={2}
                  separator=","
                  enableScrollSpy
                />
              </span>
            </motion.div>
          ))}
        </div>
        
      </div>
      <Row>
          <Col xs={12}>
            <div className="marginTop10 infoFlex">
              <i class="fa fa-info-circle"></i>
              <p className="m-0">Based on data from the last 30 days</p>
            </div>
          </Col>
        </Row>
    </Widget>
  );
};

export default PageReactios;
